module.exports = __webpack_public_path__ + "static/media/eye.45e1b1f0.svg";